<template>
  <div id="Appdown">
        <h1>Waple</h1>
        <p>Waple App 다운로드 페이지입니다.</p>
        <ul>
            <li class="android"><button type="button" @click="androidDownload">Android 다운로드</button></li>
            <li class="ios"><button type="button" @click="iosDownload">ios 다운로드</button></li>
        </ul>
        <ul style="margin-top: 10vw;">
          <button style="width:285px;height:10.6667vw;border-radius:1.3333vw;border:1px solid rgb(221,221,221);"
            type="button" @click="manualDownload">Waple App 설치 방법 매뉴얼 다운로드</button>
        </ul>
    </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      apk:'',
      plist:''
    };
  },
  methods: {
    iosDownload() {
      // 1. Safari 캐시 방지를 위해 타임스탬프 추가
      const cacheBuster = new Date().getTime();
      const plistUrl = this.plist.includes('?')
        ? `${this.plist}&_t=${cacheBuster}`
        : `${this.plist}?_t=${cacheBuster}`;

      location.href = "itms-services://?action=download-manifest&url=" + encodeURIComponent(plistUrl);
    },
    androidDownload() {
      location.href = this.apk;
    },
    manualDownload() {
      location.href = "/waple/waple_manual.pdf";
    }
  },
  created: function () {
    var that = this;
    this.$api.download
      .version()
      .then(function(data) {
        that.apk = data.apk;
        that.plist = data.plist;
      })
      .catch(function(error) {
        alert(error.rtMsg);
      });
  },
  beforeUpdate: function () {},
};
</script>
